import React from 'react';
import { Group } from 'src/design/atoms/Group';
import { useNavigate } from 'react-router-dom';
import { Header } from 'src/design/organisms/Header';
import { jobBreadcrumbs } from 'src/app/workflows/jobBreadcrumbs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { useJobs } from 'src/hooks/useJobs';
import {
  ChangeForm,
  ChangeFormValues,
} from 'src/routes/Jobs/Changes/components/ChangeForm';
import { useAuth } from 'src/hooks/useAuth';

const emptyChange: ChangeFormValues = {
  date: new Date(),
  status: 'Working',
  description: '',
  assigneeUserId: undefined,
  impactNotes: '',
  attachments: [],
  filesToAdd: [],
  filesToRemove: [],
  stepIndex: -1,
  workflow: null,
  externalContact: null,
  workflowId: 0,
  saveOnly: false,
};

export const CreateChange: React.FC = () => {
  const { selectedJob } = useJobs();
  const navigate = useNavigate();
  const { user } = useAuth();
  const initialValues = React.useMemo<ChangeFormValues>(() => {
    return {
      ...emptyChange,
      workflowId: selectedJob ? selectedJob.changeOrderWorkflowId : 0,
      workflow: selectedJob?.changeOrderWorkflow ?? null,
    };
  }, [selectedJob?.changeOrderWorkflow, user?.id]);
  if (!selectedJob) return null;

  return (
    <div>
      <Header
        breadcrumbProps={{
          items: jobBreadcrumbs(
            selectedJob,
            { text: 'Changes', href: `/jobs/${selectedJob.id}/changes` },
            'Create Change Request',
          ),
        }}
        title="Create Change Request"
        helpText="Create a new change order request for this job."
      />
      <Group justify="flex-end" mb="md">
        <SecondaryButton
          onClick={() => navigate(`/jobs/${selectedJob.id}/changes`)}
        >
          Cancel
        </SecondaryButton>
      </Group>
      <ChangeForm initialValues={initialValues} />
    </div>
  );
};
